import React from 'react';
import { useCustomHeaderTitle } from 'hooks/useCustomHeaderTitle';

type Props = {
  addTarget: () => void;
};

export const TargetListEmpty = ({ addTarget }: Props): React.ReactElement => {
  useCustomHeaderTitle('資産目標サポート');

  return (
    <>
      <div
        className="flex flex-col bg-teal-500 z-10"
        style={{ height: '310px' }}>
        <div className="mt-4 text-2xl text-white font-bold text-center">
          あなたの資産を分析！
          <br />
          将来の目標に向けてサポート
        </div>
        <div className="relative flex justify-center">
          <img
            src="/static/images/premium/target_image.png"
            alt=""
            width="220"
            height="300"
            className="absolute"
            style={{ top: '0%' }}
          />
        </div>
      </div>
      <div className="flex flex-col pt-12 bg-white">
        <div className="flex flex-row items-center justify-center">
          <div className="mt-3 mr-1 text-lg font-bold text-teal-500">
            こんな方におすすめです
          </div>
          <img src="/static/images/premium/denkyu.svg" alt="" />
        </div>
        <div className="flex flex-col pb-8 items-center">
          <div>
            <div className="flex flex-row mt-2 text-base font-bold text-bluegray-700">
              <img src="/static/images/premium/check.svg" alt="" />
              <div className="ml-2">資産運用のアドバイスが欲しい</div>
            </div>
            <div className="flex flex-row mt-2 text-base font-bold text-bluegray-700">
              <img src="/static/images/premium/check.svg" alt="" />
              <div className="ml-2">目標の進捗管理をしたい</div>
            </div>
            <div className="flex flex-row mt-2 text-base font-bold text-bluegray-700">
              <img src="/static/images/premium/check.svg" alt="" />
              <div className="ml-2">複数の目標を管理したい</div>
            </div>
          </div>
        </div>
      </div>
      {/* PC */}
      <div
        className="lg:block hidden sticky w-full bg-white p-2 shadow-fBtn"
        style={{ left: '0%', bottom: '0%' }}>
        <div className="flex justify-center">
          <div
            className="max-w-full flex flex-col px-24 py-2 mx-auto justify-center items-center text-sm font-bold text-center text-white bg-red-500 rounded-lg cursor-pointer hover:opacity-75"
            onClick={addTarget}>
            <div className="flex flex-row justify-center app-primary-label-block">
              あなたのペースで資産を育てよう
            </div>
            <div>今すぐ始める</div>
          </div>
        </div>
      </div>
      {/* SP */}
      <div
        className="lg:hidden block fixed w-full bg-white px-2 py-2 shadow-fBtn"
        style={{ left: '0%', bottom: '0%' }}>
        <div
          className="max-w-full flex flex-col py-1 items-center justify-center text-sm font-bold text-center text-white bg-red-500 rounded-lg cursor-pointer hover:opacity-75"
          onClick={addTarget}>
          <div className="flex flex-row justify-center app-primary-label-block">
            あなたのペースで資産を育てよう
          </div>
          <div>今すぐ始める</div>
        </div>
      </div>
    </>
  );
};
